import { render, staticRenderFns } from "./SplitDatePicker.vue?vue&type=template&id=484fddb5&scoped=true&"
import script from "./SplitDatePicker.vue?vue&type=script&lang=ts&"
export * from "./SplitDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./SplitDatePicker.vue?vue&type=style&index=0&id=484fddb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fddb5",
  null
  
)

export default component.exports